import Vue from "vue";
import Router from "vue-router";
import home from "@/components/pages/home.vue";
import crewSea from "@/components/pages/crewSea.vue";
import register from "@/components/pages/register.vue";
import login from "@/components/pages/login.vue";
import crewNewsDetail from "@/components/pages/crewNews/crewNewsDetail.vue";
import maritimeColumn from "@/components/pages/maritimeColumn/index.vue";
import maritimeDeclaration from "@/components/pages/maritimeColumn/maritimeDeclaration.vue";
import crewNewsMore from "@/components/pages/crewNews/crewNewsMore.vue";
import declarationReview from "@/components/pages/maritimeColumn/declarationReview.vue";
import sailorDemeanor from "@/components/pages/maritimeColumn/sailorDemeanor.vue";
import excitingSharing from "@/components/pages/maritimeColumn/excitingSharing.vue";
import jobDetail from "@/components/pages/jobTrainList/jobDetail.vue";
import trainDetail from "@/components/pages/jobTrainList/trainDetail.vue";
import noData from "@/components/pages/noData/noData.vue";
import otherPage from "@/components/pages/otherPage/otherIs.vue";
import applyAdd from "@/components/pages/otherPage/applyAdd/applyAdd.vue";
import laborApplyList from "@/components/pages/otherPage/applyAdd/laborApplyList.vue";
import laborPassList from "@/components/pages/otherPage/applyAdd/laborPassList.vue";
import crewHome from "@/components/pages/otherPage/crewHome.vue";
import inviteCrew from "@/components/pages/otherPage/selectedCrew/inviteCrew.vue";
import deliveryCrew from "@/components/pages/otherPage/selectedCrew/deliveryCrew.vue";
import unpassCrew from "@/components/pages/otherPage/selectedCrew/unpassCrew.vue";
import offlineOver from "@/components/pages/otherPage/positionManagement/offlineOver.vue";
import progressIn from "@/components/pages/otherPage/positionManagement/progressIn.vue";
import addCrewJob from "@/components/pages/otherPage/positionManagement/addCrewJob.vue";
import crewPass from "@/components/pages/otherPage/positionManagement/crewPass.vue";
import crewDetail from "@/components/pages/otherPage/crewPage/crewDetail.vue";
import addCrew from "@/components/pages/otherPage/addCrew/addCrew.vue";
import inviteAdd from "@/components/pages/otherPage/selectedCrew/inviteAdd.vue";
import inviteDetail from "@/components/pages/otherPage/selectedCrew/inviteDetail.vue";
import inviteDetail2 from "@/components/pages/otherPage/selectedCrew/inviteDetail.vue";
import inviteDetail3 from "@/components/pages/otherPage/selectedCrew/inviteDetail.vue";
import companyDetail from "@/components/pages/otherPage/companyDetail/companyDetail.vue";
import aboutUs from "@/components/pages/aboutUs/aboutUs.vue";
import crewProblem from "@/components/pages/crewProblem/crewProblem.vue";
import healthView from "@/components/pages/healthView/healthView.vue";
import shipInformation from "@/components/pages/shipInformation/shipInformation.vue";
import passCert from "@/components/pages/passCert/passCert.vue";
import laborSalary from "@/components/pages/otherPage/salaryList/laborSalary.vue";
import laborCosts from "@/components/pages/otherPage/salaryList/laborCosts.vue";
import energySaving from "@/components/pages/otherPage/salaryList/energySaving.vue";
import excellentCrew from "@/components/pages/otherPage/salaryList/excellentCrew.vue";
import shipAudit from "@/components/pages/otherPage/salaryList/shipAudit.vue";
import crewFood from "@/components/pages/otherPage/salaryList/crewFood.vue";
import otherRewards from "@/components/pages/otherPage/salaryList/otherRewards.vue";
import laborDetail from "@/components/pages/otherPage/salaryDetail/laborDetail.vue";
import energyDetail from "@/components/pages/otherPage/salaryDetail/energyDetail.vue";
import excellentDetail from "@/components/pages/otherPage/salaryDetail/excellentDetail.vue";
import shipAuditDetail from "@/components/pages/otherPage/salaryDetail/shipAuditDetail.vue";
import crewFoodDetail from "@/components/pages/otherPage/salaryDetail/crewFoodDetail.vue";
import rewardsDetail from "@/components/pages/otherPage/salaryDetail/rewardsDetail.vue";
import costDetail from "@/components/pages/otherPage/salaryDetail/costDetail.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/crewSea",
      name: "crewSea",
      component: crewSea,
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "home",
          component: home,
          meta: {
            title: "船员服务平台",
          },
        },
        {
          path: "/maritimeColumn",
          name: "maritimeColumn",
          component: maritimeColumn,
          meta: {
            title: "海事专栏",
          },
        },
        {
          path: "/aboutUs",
          name: "aboutUs",
          component: aboutUs,
          meta: {
            title: "关于我们",
          },
        },
        {
          path: "/crewProblem",
          name: "crewProblem",
          component: crewProblem,
          meta: {
            title: "船员咨询",
          },
        },
        {
          path: "/healthView",
          name: "healthView",
          component: healthView,
          meta: {
            title: "健康体检",
          },
        },
        {
          path: "/shipInformation",
          name: "shipInformation",
          component: shipInformation,
          meta: {
            title: "航运百科",
          },
        },
        {
          path: "/maritimeDeclaration",
          name: "maritimeDeclaration",
          component: maritimeDeclaration,
          meta: {
            hideFooter: true,
            title: "企业报备",
          },
        },
        {
          path: "/excitingSharing",
          name: "excitingSharing",
          component: excitingSharing,
          meta: {
            title: "精彩分享",
          },
        },
        {
          path: "/sailorDemeanor",
          name: "sailorDemeanor",
          component: sailorDemeanor,
          meta: {
            title: "海员风采",
          },
        },
        {
          path: "/jobDetail/:positionOrCompany",
          name: "jobDetail",
          component: jobDetail,
          meta: {
            title: "船员招聘",
          },
        },
        {
          path: "/trainDetail/:trainTitle",
          name: "trainDetail",
          component: trainDetail,
          meta: {
            title: "船员培训",
          },
        },
        {
          path: "/crewNewsMore",
          name: "crewNewsMore",
          component: crewNewsMore,
          meta: {
            title: "航运资讯",
          },
        },
        {
          path: "/crewNewsDetail/:id",
          name: "crewNewsDetail",
          component: crewNewsDetail,
          meta: {
            title: "航运资讯",
          },
        },
        {
          path: "/noData",
          name: "noData",
          component: noData,
          meta: {
            title: "开发中",
          },
        },
      ],
    },
    {
      path: "/register",
      name: "register",
      component: register,
      meta: {
        hideHeaderFooter: true,
        title: "注册",
      },
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: {
        hideHeaderFooter: true,
        title: "登录",
      },
    },
    {
      path: "/passCert",
      name: "passCert",
      component: passCert,
      meta: {
        title: "证书授权",
      },
    },
    {
      path: "/declarationReview",
      name: "declarationReview",
      component: declarationReview,
      meta: {
        hideHeaderFooter: true,
        title: "海事审阅",
      },
    },
    {
      path: "/otherPage",
      name: "otherPage",
      component: otherPage,
      redirect: "/otherHome",
      meta: {
        title: "首页",
        breadcrumb: true,
      },
      children: [
        {
          path: "/otherHome",
          name: "船员库",
          component: crewHome,
          meta: {
            title: "船员库",
            breadcrumb: true,
          },
        },
        {
          path: "/crewDetail/:name/:userId",
          name: "crewDetail",
          component: crewDetail,
          meta: {
            title: "船员详情",
            breadcrumb: true,
          },
        },
        {
          path: "/addCrew/:userId",
          name: "addCrew",
          component: addCrew,
          meta: {
            title: "添加船员",
            breadcrumb: true,
          },
        },
        {
          path: "/inviteAdd/:name",
          name: "inviteAdd",
          component: inviteAdd,
          meta: {
            title: "邀请船员",
            breadcrumb: true,
          },
        },
        {
          path: "/inviteDetail/:name/:userId/:passFlag/:agentCyAuditId",
          name: "inviteDetail",
          component: inviteDetail,
          meta: {
            title: "船员详情",
            breadcrumb: true,
          },
        },
        {
          path: "/inviteDetail2/:name/:userId/:passFlag/:cyResumeSendId",
          name: "inviteDetail2",
          component: inviteDetail2,
          meta: {
            title: "船员详情",
            breadcrumb: true,
          },
        },
        {
          path: "/inviteDetail3/:name/:userId/:passFlag",
          name: "inviteDetail3",
          component: inviteDetail3,
          meta: {
            title: "船员详情",
            breadcrumb: true,
          },
        },
        {
          path: "/addCrewJob/:name",
          name: "addCrewJob",
          component: addCrewJob,
          meta: {
            title: "发布职位",
            breadcrumb: true,
          },
        },
        {
          path: "/addCrewJob2/:name",
          name: "addCrewJob2",
          component: addCrewJob,
          meta: {
            title: "发布职位",
            breadcrumb: true,
          },
        },
        {
          path: "/inviteCrew",
          name: "邀请船员",
          component: inviteCrew,
          meta: {
            title: "邀请船员",
            breadcrumb: true,
          },
        },
        {
          path: "/applyAdd",
          name: "新建申请",
          component: applyAdd,
          meta: {
            title: "新建申请",
            breadcrumb: true,
          },
        },
        {
          path: "/laborApplyList",
          name: "我的申请",
          component: laborApplyList,
          meta: {
            title: "我的申请",
            breadcrumb: true,
          },
        },
        {
          path: "/laborPassList",
          name: "我的审批",
          component: laborPassList,
          meta: {
            title: "我的审批",
            breadcrumb: true,
          },
        },
        {
          path: "/deliveryCrew",
          name: "投递船员",
          component: deliveryCrew,
          meta: {
            title: "投递船员",
            breadcrumb: true,
          },
        },
        {
          path: "/unpassCrew",
          name: "未通过",
          component: unpassCrew,
          meta: {
            title: "未通过",
            breadcrumb: true,
          },
        },
        {
          path: "/offlineOver",
          name: "已下线",
          component: offlineOver,
          meta: {
            title: "已下线",
            breadcrumb: true,
          },
        },
        {
          path: "/progressIn",
          name: "招聘中",
          component: progressIn,
          meta: {
            title: "招聘中",
            breadcrumb: true,
          },
        },
        {
          path: "/laborSalary",
          name: "劳务薪资",
          component: laborSalary,
          meta: {
            title: "劳务薪资",
            breadcrumb: true,
          },
        },
        {
          path: "/laborCosts",
          name: "劳务费用",
          component: laborCosts,
          meta: {
            title: "劳务费用",
            breadcrumb: true,
          },
        },
        {
          path: "/energySaving",
          name: "节能考核",
          component: energySaving,
          meta: {
            title: "节能考核",
            breadcrumb: true,
          },
        },
        {
          path: "/excellentCrew",
          name: "优秀船员奖励",
          component: excellentCrew,
          meta: {
            title: "优秀船员奖励",
            breadcrumb: true,
          },
        },
        {
          path: "/shipAudit",
          name: "船舶考核",
          component: shipAudit,
          meta: {
            title: "船舶考核",
            breadcrumb: true,
          },
        },
        {
          path: "/crewFood",
          name: "外来人员客餐费",
          component: crewFood,
          meta: {
            title: "外来人员客餐费",
            breadcrumb: true,
          },
        },
        {
          path: "/otherRewards",
          name: "其他奖励",
          component: otherRewards,
          meta: {
            title: "其他奖励",
            breadcrumb: true,
          },
        },
        {
          path: "/laborDetail/:id/:type/:bol",
          name: "laborDetail",
          component: laborDetail,
          meta: {
            title: "劳务薪资详情",
            breadcrumb: true,
          },
        },
        {
          path: "/energyDetail/:id/:type",
          name: "energyDetail",
          component: energyDetail,
          meta: {
            title: "节能考核详情",
            breadcrumb: true,
          },
        },
        {
          path: "/excellentDetail/:id/:type",
          name: "excellentDetail",
          component: excellentDetail,
          meta: {
            title: "优秀船员详情",
            breadcrumb: true,
          },
        },
        {
          path: "/shipAuditDetail/:id/:type/:month",
          name: "shipAuditDetail",
          component: shipAuditDetail,
          meta: {
            title: "船舶考核详情",
            breadcrumb: true,
          },
        },
        {
          path: "/crewFoodDetail/:id/:type",
          name: "crewFoodDetail",
          component: crewFoodDetail,
          meta: {
            title: "客餐费详情",
            breadcrumb: true,
          },
        },
        {
          path: "/rewardsDetail/:id/:type",
          name: "rewardsDetail",
          component: rewardsDetail,
          meta: {
            title: "其他奖励详情",
            breadcrumb: true,
          },
        },
        {
          path: "/costDetail/:id/:type",
          name: "costDetail",
          component: costDetail,
          meta: {
            title: "劳务费用详情",
            breadcrumb: true,
          },
        },
        {
          path: "/companyDetail",
          name: "企业信息",
          component: companyDetail,
          meta: {
            title: "企业信息",
          },
        },
        {
          path: "/crewPass/:jobId",
          name: "crewPass",
          component: crewPass,
          meta: {
            title: "已投递船员列表",
            breadcrumb: true,
          },
        },
        {
          path: "/crewPass2/:jobId",
          name: "crewPass2",
          component: crewPass,
          meta: {
            title: "已投递船员列表",
            breadcrumb: true,
          },
        },
      ],
    },

    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "*",
      redirect: "/home",
    },
  ],
});
const breadcrumbsStruct = [
  {
    name: "otherPage",
    children: [
      {
        name: "船员库",
        children: [{ name: "crewDetail" }, { name: "addCrew" }],
      },
      {
        name: "邀请船员",
        children: [{ name: "inviteDetail" }, { name: "inviteAdd" }],
      },
      {
        name: "投递船员",
        children: [{ name: "inviteDetail2" }],
      },
      {
        name: "未通过",
        children: [{ name: "inviteDetail3" }],
      },
      {
        name: "招聘中",
        children: [{ name: "addCrewJob" }, { name: "crewPass" }],
      },
      {
        name: "已下线",
        children: [{ name: "addCrewJob2" }, { name: "crewPass2" }],
      },
      {
        name: "劳务薪资",
        children: [{ name: "laborDetail" }],
      },
      {
        name: "劳务费用",
        children: [{ name: "costDetail" }],
      },
      {
        name: "节能考核",
        children: [{ name: "energyDetail" }],
      },
      {
        name: "优秀船员奖励",
        children: [{ name: "excellentDetail" }],
      },
      {
        name: "其他奖励",
        children: [{ name: "rewardsDetail" }],
      },
      {
        name: "船舶考核",
        children: [{ name: "shipAuditDetail" }],
      },
      {
        name: "外来人员客餐费",
        children: [{ name: "crewFoodDetail" }],
      },
      {
        name: "新建申请",
        children: [{ name: "applyAdd" }],
      },
      {
        name: "我的申请",
        children: [{ name: "laborApplyList" }],
      },
      {
        name: "我的审批",
        children: [{ name: "laborPassList" }],
      },
    ],
  },
];

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});
router.afterEach((to) => {
  const target = to.name;
  const data = [];
  let finalData = data;
  function dfs(arr) {
    // 在 breadcrumbsStruct 查找 target，且记录下树上的路径
    if (!arr || !arr.length) {
      return;
    }
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];
      data.push(item.name);
      if (item.name === target) {
        finalData = JSON.parse(JSON.stringify(data));
        break;
      }
      // 向深一级查找，查不到应该回溯
      dfs(item.children);
      data.pop();
    }
  }
  dfs(breadcrumbsStruct);
  const routeList = router.getRoutes();
  const routeInfoList = finalData.map((item) => {
    const info = routeList.find((r) => r.name === item);
    if (info) {
      return info;
    } else {
      console.error("构建路径失败");
    }
  });

  routeInfoList[0].path = "/otherHome";
  routeInfoList.forEach((el, index) => {
    if (index == 1) {
      el.title = el.meta.mainTitle;
    } else {
      el.title = el.meta.title;
    }
  });
  // console.log(routeInfoList);
  router.globalData = {
    routeInfoList: routeInfoList,
  };
  // store.commit("SETNEWBREADLIST", routeInfoList);
});

export default router;
